export default __webpack_public_path__ + "94679fc3de8bd97aba31943fbfbe51cb.svg";